import { render, staticRenderFns } from "./pip-details.vue?vue&type=template&id=a93a2660&"
import script from "./pip-details.vue?vue&type=script&lang=js&"
export * from "./pip-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pip-details.vue"
export default component.exports